"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _downshift = _interopRequireDefault(require("downshift"));
var _icons = require("./icons");
var _itemList = _interopRequireDefault(require("./item-list"));
var _styles = require("./styles");
var _stateReducer = _interopRequireDefault(require("./state-reducer"));
const SearchTypeahead = _ref => {
  let {
    items,
    placeholder,
    maxHeight,
    itemToString,
    onSubmit,
    truncate,
    footer,
    disableCloseOnSelect,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_downshift.default, (0, _extends2.default)({}, props, {
    itemToString: itemToString,
    stateReducer: (0, _stateReducer.default)({
      disableCloseOnSelect
    })
  }), _ref2 => {
    let {
      getInputProps,
      getItemProps,
      isOpen,
      inputValue,
      highlightedIndex,
      closeMenu
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_styles.InputGroupInput, getInputProps({
      placeholder: placeholder,
      autocomplete: 'off',
      role: 'combobox',
      ['aria-expanded']: isOpen,
      ['aria-autocomplete']: 'list',
      ['aria-controls']: 'search-typeahead-option-list',
      ['aria-owns']: 'search-typeahead-option-list',
      onKeyDown: event => {
        if (event.key === 'Enter' && highlightedIndex === null) {
          event.preventDownshiftDefault = true;
          closeMenu();
        } else {
          event.preventDownshiftDefault = false;
        }
      }
    })), /*#__PURE__*/_react.default.createElement(_styles.InputGroupButton, {
      className: "ky-button ky-btn-positive kyruus-config-secondary-color",
      onClick: onSubmit,
      "aria-label": "Search",
      mode: "primary"
    }, /*#__PURE__*/_react.default.createElement(_icons.SearchContrast, null)), /*#__PURE__*/_react.default.createElement(_styles.StyledPaper, {
      id: "search-typeahead-option-list",
      className: "option-list",
      "data-placement": "below",
      "data-max-height": `${maxHeight}px`,
      maxHeight: maxHeight,
      elevation: 4,
      role: "listbox"
    }, isOpen && /*#__PURE__*/_react.default.createElement(_itemList.default, {
      items: items,
      useTypeahead: true,
      itemToString: itemToString,
      highlightedIndex: highlightedIndex,
      inputValue: inputValue,
      getItemProps: getItemProps,
      maxHeight: maxHeight,
      truncate: truncate,
      footer: footer
    })));
  });
};
SearchTypeahead.propTypes = {
  ..._downshift.default.propTypes,
  /**
   * The list of items that can be selected from: either a list of strings or a list of objects.
   */
  items: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string])),
  /**
   * Function defining how the object should be rendered.
   * Only necessary when the list of items passed in are objects.
   * Example: if items are of the format {id: 1, text: 'apple'},
   * you would want itemToString to be: (item) => item ? item.text : ''
   */
  itemToString: _propTypes.default.func,
  /**
   * Used to display placeholder text inside the input.
   */
  placeholder: _propTypes.default.string,
  /**
   * A number that sets the max height of the dropdown in pixels
   * (e.g. 100)
   * If not all items fit within the set height,
   * the user will need to scroll to see the other options.
   */
  maxHeight: _propTypes.default.number,
  /**
   * The function to be used as the onClick handler for the rendered button.
   */
  onSubmit: _propTypes.default.func,
  /**
   * Whether or not to truncate the text of typeahead results to fit on a single line.
   */
  truncate: _propTypes.default.bool,
  /**
   * An optional footer node to include at the bottom of the open results container.
   * This is useful for including things like the "powered by Google" image for location autocomplete.
   */
  footer: _propTypes.default.node,
  /**
   * When set to true, this disables the menu closing upon selection of an item.
   */
  disableCloseOnSelect: _propTypes.default.bool
};
SearchTypeahead.defaultProps = {
  ..._downshift.default.defaultProps,
  items: [],
  truncate: false,
  disableCloseOnSelect: false
};
var _default = exports.default = SearchTypeahead;
SearchTypeahead.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SearchTypeahead",
  "props": {
    "items": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "The list of items that can be selected from: either a list of strings or a list of objects.",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "union",
          "value": [{
            "name": "object"
          }, {
            "name": "string"
          }]
        }
      },
      "required": false
    },
    "truncate": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Whether or not to truncate the text of typeahead results to fit on a single line.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "disableCloseOnSelect": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "When set to true, this disables the menu closing upon selection of an item.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "itemToString": {
      "description": "Function defining how the object should be rendered.\nOnly necessary when the list of items passed in are objects.\nExample: if items are of the format {id: 1, text: 'apple'},\nyou would want itemToString to be: (item) => item ? item.text : ''",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "placeholder": {
      "description": "Used to display placeholder text inside the input.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "maxHeight": {
      "description": "A number that sets the max height of the dropdown in pixels\n(e.g. 100)\nIf not all items fit within the set height,\nthe user will need to scroll to see the other options.",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "onSubmit": {
      "description": "The function to be used as the onClick handler for the rendered button.",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "footer": {
      "description": "An optional footer node to include at the bottom of the open results container.\nThis is useful for including things like the \"powered by Google\" image for location autocomplete.",
      "type": {
        "name": "node"
      },
      "required": false
    }
  },
  "composes": ["downshift"]
};